/**
 * 受保護的路由元件
 * 參考 towconnect-web 的 ProtectedRoute.tsx
 * 整合 LIFF 認證檢查
 */

import React from 'react'
import { Navigate } from 'react-router-dom'
import { useLiff } from '@/contexts/LiffContext'
import { Box, CircularProgress, Typography } from '@mui/material'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoggedIn, loading, error } = useLiff()

  // 載入中
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          正在初始化...
        </Typography>
      </Box>
    )
  }

  // 錯誤狀態
  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
          p: 3,
        }}
      >
        <Typography variant="h6" color="error">
          初始化失敗
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {error}
        </Typography>
      </Box>
    )
  }

  // 未登入 - 導向入口頁面
  if (!isLoggedIn) {
    return <Navigate to="/" replace />
  }

  // 已登入 - 顯示內容
  return <>{children}</>
}

export default ProtectedRoute
